import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import * as i0 from "@angular/core";
export let MatomoInjector = /*#__PURE__*/(() => {
  class MatomoInjector {
    constructor(platformId) {
      this.platformId = platformId;
    }
    init(url, id, scriptUrl) {
      if (!isPlatformBrowser(this.platformId)) return;
      if (typeof id === 'string') id = parseInt(id, 10);
      if (!url || !id) return false;
      window._paq = window._paq || [];
      window._paq.push(['trackPageView']);
      window._paq.push(['enableLinkTracking']);
      (() => {
        const u = url;
        window._paq.push(['setTrackerUrl', u + 'piwik.php']);
        window._paq.push(['setSiteId', id.toString()]);
        const d = document;
        const g = d.createElement('script');
        const s = d.getElementsByTagName('script')[0];
        g.type = 'text/javascript';
        g.async = true;
        g.defer = true;
        g.src = scriptUrl ? scriptUrl : u + 'piwik.js';
        s.parentNode.insertBefore(g, s);
      })();
    }
    static {
      this.ɵfac = function MatomoInjector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatomoInjector)(i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: MatomoInjector,
        factory: MatomoInjector.ɵfac
      });
    }
  }
  return MatomoInjector;
})();